module.exports = __webpack_public_path__ + "img/apple.6450b34d.svg";